import React from 'react';
import { createApolloClient } from './apolloClient';

export class MercuryConnection {
  constructor() {
    this.apolloClient = createApolloClient();
  }
}

const MercuryContext = React.createContext(null);

export default MercuryContext;
